import { Accordion } from 'components/Accordion'
import React from 'react'
import styled from 'styled-components'

const ThinkingMessage = styled.div`
  color: ${({ theme }) => theme.forecast.tertiaryText};
  font-style: italic;
  padding: 0.25rem 0;
`

const ThoughtsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`

const AccordionWrapper = styled.div`
  width: 100%;
  max-width: 80%;

  button[data-state] {
    justify-content: flex-start;
    gap: 0.25rem;
  }
`

interface ThoughtsAccordionProps {
  accordionKey: string
  title: string
  thoughts: Array<{ text: React.ReactNode }>
}

export const ThoughtsAccordion: React.FC<ThoughtsAccordionProps> = ({
  accordionKey,
  title,
  thoughts,
}) => {
  return (
    <AccordionWrapper>
      <Accordion
        items={[
          {
            key: accordionKey,
            title,
            content: (
              <ThoughtsContainer>
                {thoughts.map((message, msgIndex) => (
                  <ThinkingMessage key={msgIndex}>
                    {message.text}
                  </ThinkingMessage>
                ))}
              </ThoughtsContainer>
            ),
          },
        ]}
        defaultValue={[accordionKey]}
      />
    </AccordionWrapper>
  )
}
